import React, { Component } from 'react';
import './Styles.css'

export default class Error extends Component {
    render() {
        return (
            <div className='erro'>             
                Erro 404 Página não encontrada
            </div>
        );
    }
}
